
const loadFont = (option) => {
    let newStyle = document.createElement('style');
    var u = navigator.userAgent;
    var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
    if (isAndroid) {
        newStyle.appendChild(
            document.createTextNode(
                `@font-face {\
        	font-family: "fzlt";\
        	src: url("//widgetframe.ppdaicdn.com/1.0.7/res/font/fzlt.ttf") format("truetype");\
        		}`
            )
        );
        newStyle.appendChild(
            document.createTextNode(
                `@font-face {\
        	font-family: "fzlt_bold";\
        	src: url("//widgetframe.ppdaicdn.com/1.0.7/res/font/fzlt_bold.ttf") format("truetype");\
        		}`
            )
        );
        newStyle.appendChild(
            document.createTextNode(
                `@font-face {\
        	font-family: "uni_sans_regular";\
        	src: url("//widgetframe.ppdaicdn.com/1.0.7/res/font/uni_sans_regular.otf") format("truetype");\
        		}`
            )
        );
        newStyle.appendChild(
            document.createTextNode(
                `@font-face {\
        	font-family: "number";\
        	src: url("//widgetframe.ppdaicdn.com/1.0.7/res/font/uni_sans_regular.otf") format("truetype");\
        		}`
            )
        );
        newStyle.appendChild(
            document.createTextNode(
                `@font-face {\
        	font-family: "number_light";\
        	src: url("//widgetframe.ppdaicdn.com/1.0.7/res/font/uni_sans_regular.otf") format("truetype");\
        		}`
            )
        );
    } else {
        newStyle.appendChild(
            document.createTextNode(
                `@font-face {\
        	font-family: "fzlt";\
        	src: url("//widgetframe.ppdaicdn.com/1.0.7/res/font/fzlt.ttf") format("truetype");\
        		}`
            )
        );
        newStyle.appendChild(
            document.createTextNode(
                `@font-face {\
        	font-family: "fzlt_bold";\
        	src: url("//widgetframe.ppdaicdn.com/1.0.7/res/font/fzlt_bold.ttf") format("truetype");\
        		}`
            )
        );
        newStyle.appendChild(
            document.createTextNode(
                `@font-face {\
        	font-family: "uni_sans_regular";\
        	src: url("//widgetframe.ppdaicdn.com/1.0.7/res/font/uni_sans_regular.otf") format("truetype");\
        		}`
            )
        );
        newStyle.appendChild(
            document.createTextNode(
                `@font-face {\
        	font-family: "number";\
        	src: url("//widgetframe.ppdaicdn.com/1.0.7/res/font/uni_sans_regular.otf") format("truetype");\
        		}`
            )
        );
        newStyle.appendChild(
            document.createTextNode(
                `@font-face {\
        	font-family: "number_light";\
        	src: url("//widgetframe.ppdaicdn.com/1.0.7/res/font/uni_sans_regular.otf") format("truetype");\
        		}`
            )
        );
    }
    if (document.head) {
        document.head.appendChild(newStyle);
    } else {
        let tag = document.getElementsByTagName('script')[0];
        tag.parentNode && tag.parentNode.insertBefore(newStyle, tag);
    }
};

export default loadFont;